import classNames from "classnames";
import { range } from "../../../utils/arrays";
import { fixRatings } from "../../../utils/numbers";
import styles from "./ratingstars.module.scss";
import React from "react";

function RatingStars(props) {
  const { size, clickable, className, basic, onChange, addSeoTag } = props;
  const value = fixRatings(props.value);
  const seoProps = addSeoTag
    ? {
        itemProp: "aggregateRating",
        itemScope: true,
        itemType: "https://schema.org/AggregateRating",
      }
    : {};
  return (
    <div {...seoProps} className={classNames(styles.ratingHolder, { [styles.basic]: basic }, className)}>
      {addSeoTag && (
        <>
          <meta itemProp="ratingValue" content={props.value} />
          <meta itemProp="worstRating" content="1" />
          <meta itemProp="bestRating" content="5" />
          <meta itemProp="ratingCount" content={props.votes} />
        </>
      )}
      <div
        data-rating-value={value}
        className={classNames(
          styles.cRating,
          clickable ? styles.clickable : styles.unClickable,
          styles[`rating-${size}`]
        )}
      >
        {range(5).map((i) => (
          <span key={i} disabled={!clickable} onClick={onChange.bind(null, i + 1)}>
            {i + 1}
          </span>
        ))}
      </div>
    </div>
  );
}

RatingStars.defaultProps = {
  size: "large",
  onChange: function () {
    return null;
  },
};

export default RatingStars;
